<template>
  <v-container fluid class="py-0">
    <v-row>
      <!-- LEFT COLUMN: Description, Members, Managers -->
      <v-col cols="12" md="5" class="custom-border-right pr-md-4">
        <!-- Retained hidden table for API / data structure compatibility -->
        <table class="width-100" v-if="false">
          <tr>
            <td class="pb-2 font-size-18 text-capitalize">Project #</td>
            <td class="pb-2 font-size-18 text-capitalize">
              {{ projectArr.barcode }}
            </td>
          </tr>
          <tr>
            <td class="pb-2 font-size-18 text-capitalize">Reference #</td>
            <td class="pb-2 font-size-18 text-capitalize">
              <template v-if="projectArr.reference">
                {{ projectArr.reference }}
              </template>
              <template v-else>
                <em class="text--secondary">No Reference</em>
              </template>
            </td>
          </tr>
          <tr>
            <td class="pb-2 font-size-18 text-capitalize">Customer</td>
            <td class="pb-2 font-size-18 text-capitalize">
              <template v-if="projectArr.customer">
                <template
                  v-if="projectArr.customer && projectArr.customer.display_name"
                >
                  {{ projectArr.customer.display_name }}
                </template>
              </template>
              <template v-else
                ><em class="text--secondary">No Customer</em></template
              >
            </td>
          </tr>
          <tr>
            <td class="pb-2 font-size-18 text-capitalize">Start Date</td>
            <td class="pb-2 font-size-18 text-capitalize">
              <template v-if="projectArr.started_at">{{
                formatDate(projectArr.started_at)
              }}</template>
              <template v-else
                ><em class="text--secondary">Not Start Date</em></template
              >
            </td>
          </tr>
          <tr>
            <td class="pb-2 font-size-18 text-capitalize">End Date</td>
            <td class="pb-2 font-size-18 text-capitalize">
              <template v-if="projectArr.deadline">{{
                formatDate(projectArr.deadline)
              }}</template>
              <template v-else
                ><em class="text--secondary">No End Date</em></template
              >
            </td>
          </tr>
          <tr>
            <td class="pb-2 font-size-18 text-capitalize">Commencement Date</td>
            <td class="pb-2 font-size-18 text-capitalize">
              <template v-if="projectArr.commencement_date">{{
                formatDate(projectArr.commencement_date)
              }}</template>
              <template v-else
                ><em class="text--secondary">No End Date</em></template
              >
            </td>
          </tr>
          <tr>
            <td class="pb-2 font-size-18 text-capitalize">Frequency</td>
            <td class="pb-2 font-size-18 text-capitalize">
              <template v-if="projectArr.frequency">{{
                projectArr.frequency
              }}</template>
              <template v-else
                ><em class="text--secondary">No Frequency</em></template
              >
            </td>
          </tr>
          <tr>
            <td class="pb-2 font-size-18 text-capitalize">
              Contract No. Of Years
            </td>
            <td class="pb-2 font-size-18 text-capitalize">
              <template v-if="projectArr.contract_years">
                <div>
                  <v-avatar
                    size="28"
                    color="blue"
                    class="white--text d-flex justify-center align-center"
                  >
                    <span class="text-center" style="font-size: 12px">
                      {{ projectArr.contract_years }}
                    </span>
                  </v-avatar>
                </div>
              </template>
              <template v-else
                ><em class="text--secondary">No Contract Years</em></template
              >
            </td>
          </tr>
          <tr v-if="false">
            <td class="pb-2 font-size-18 font-weight-500 text-capitalize">
              Total Logged Hours
            </td>
            <td class="pb-2 font-size-18 font-weight-600 text-capitalize">
              <template v-if="projectArr.total_logged_hours">{{
                projectArr.total_logged_hours
              }}</template>
              <template v-else
                ><em class="text--secondary">No Logged Hours</em></template
              >
            </td>
          </tr>
        </table>

        <div class="project-section">
          <!-- DESCRIPTION CARD -->
          <v-card outlined class="shadow-0 mb-4">
            <v-card-title
              class="py-2 px-4 d-flex align-items-center border-bottom gray-background"
            >
              <v-icon small color="cyan darken-2" class="mr-2"
                >mdi-text-box-outline</v-icon
              >
              <span
                class="font-size-16 text-capitalize color-custom-blue font-weight-700 text-uppercase"
              >
                Description
              </span>
            </v-card-title>
            <v-card-text class="pa-4">
              <template v-if="projectArr.description">
                <read-more
                  class="custom-read-more font-size-15"
                  more-str="read more"
                  less-str="read less"
                  :max-chars="200"
                  :text="projectArr.description"
                />
              </template>
              <template v-else>
                <em class="text-muted font-size-14"
                  >No description for this project</em
                >
              </template>
            </v-card-text>
          </v-card>

          <!-- MEMBERS CARD -->
          <v-card
            outlined
            class="shadow-0 mb-4 overflow-hidden"
            v-if="projectArr.members"
          >
            <v-card-title
              class="py-2 px-4 d-flex align-items-center border-bottom gray-background"
            >
              <v-icon small color="cyan darken-2" class="mr-2"
                >mdi-account-group</v-icon
              >
              <span
                class="font-size-16 text-capitalize color-custom-blue font-weight-700 text-uppercase"
              >
                Members
              </span>
              <v-chip
                v-if="projectArr.members && projectArr.members.length"
                small
                class="ml-2 font-weight-600"
                color="cyan lighten-5"
                text-color="cyan darken-3"
              >
                {{ projectArr.members.length }}
              </v-chip>
              <v-spacer></v-spacer>
              <v-btn
                icon
                small
                v-if="getPermission('project:update') && projectArr.status < 4"
                @click="memberDialog = true"
              >
                <v-icon color="cyan">mdi-cog</v-icon>
              </v-btn>
            </v-card-title>

            <v-card-text class="pa-0">
              <v-list dense v-if="projectArr.members.length" class="py-0">
                <v-list-item
                  v-for="(member, index) in projectArr.members"
                  :key="index"
                  class="hover-row border-bottom py-1"
                >
                  <v-list-item-avatar size="38">
                    <v-img
                      :lazy-src="$defaultProfileImage"
                      :src="$assetAPIURL(member.user.profile_logo)"
                    />
                  </v-list-item-avatar>

                  <v-list-item-content>
                    <v-list-item-title class="font-weight-600 font-size-15">
                      {{ member.user.full_name }}
                    </v-list-item-title>
                  </v-list-item-content>

                  <v-list-item-action>
                    <v-btn
                      icon
                      small
                      v-if="
                        getPermission('project:delete') && projectArr.status < 4
                      "
                      @click="deleteMember(member)"
                    >
                      <v-icon color="red lighten-1">mdi-delete</v-icon>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
              </v-list>

              <div v-else class="empty-state text-center text-muted py-4">
                <v-icon size="30" color="grey lighten-1"
                  >mdi-account-off</v-icon
                >
                <div class="font-size-14 mt-1">No members exist.</div>
              </div>
            </v-card-text>
          </v-card>

          <!-- MANAGERS CARD -->
          <v-card
            outlined
            class="shadow-0 mb-4 overflow-hidden"
            v-if="projectArr.managers"
          >
            <v-card-title
              class="py-2 px-4 d-flex align-items-center border-bottom gray-background"
            >
              <v-icon small color="cyan darken-2" class="mr-2"
                >mdi-account-tie</v-icon
              >
              <span
                class="font-size-16 text-capitalize color-custom-blue font-weight-700 text-uppercase"
              >
                Managers
              </span>
              <v-chip
                v-if="projectArr.managers && projectArr.managers.length"
                small
                class="ml-2 font-weight-600"
                color="cyan lighten-5"
                text-color="cyan darken-3"
              >
                {{ projectArr.managers.length }}
              </v-chip>
              <v-spacer></v-spacer>
              <v-btn
                icon
                small
                v-if="getPermission('project:update') && projectArr.status < 4"
                @click="managerDialog = true"
              >
                <v-icon color="cyan">mdi-cog</v-icon>
              </v-btn>
            </v-card-title>

            <v-card-text class="pa-0">
              <v-list dense v-if="projectArr.managers.length" class="py-0">
                <v-list-item
                  v-for="(manager, index) in projectArr.managers"
                  :key="index"
                  class="hover-row border-bottom py-1"
                >
                  <v-list-item-avatar size="38">
                    <v-img
                      :lazy-src="$defaultProfileImage"
                      :src="$assetAPIURL(manager.user.profile_logo)"
                    />
                  </v-list-item-avatar>

                  <v-list-item-content>
                    <v-list-item-title class="font-weight-600 font-size-15">
                      {{ manager.user.full_name }}
                    </v-list-item-title>
                  </v-list-item-content>

                  <v-list-item-action>
                    <v-btn
                      icon
                      small
                      v-if="
                        getPermission('project:delete') && projectArr.status < 4
                      "
                      @click="deleteManager(manager)"
                    >
                      <v-icon color="red lighten-1">mdi-delete</v-icon>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
              </v-list>

              <div v-else class="empty-state text-center text-muted py-4">
                <v-icon size="30" color="grey lighten-1"
                  >mdi-account-cancel</v-icon
                >
                <div class="font-size-14 mt-1">No manager exists.</div>
              </div>
            </v-card-text>
          </v-card>
        </div>
      </v-col>

      <!-- RIGHT COLUMN: Banker Guarantee & Insurance Project -->
      <v-col cols="12" md="7" class="pl-md-4">
        <!-- Retained hidden table for schema/data structure compatibility -->
        <table width="100%" v-if="false">
          <tr>
            <th
              colspan="2"
              class="font-size-16 color-custom-blue py-2 custom-border-bottom text-uppercase"
            >
              Project Costing
            </th>
          </tr>
          <tr>
            <td class="font-size-18 font-weight-500 py-2" width="200">Value</td>
            <td class="font-size-18 py-2" width="200">
              <span
                class="text--uppercase pr-2 font-weight-600"
                v-if="projectArr && projectArr.project_value"
                >{{ formatMoney(projectArr.project_value) }}</span
              >
              <em v-else class="text--secondary"> no Project Value</em>
            </td>
          </tr>
          <tr>
            <td class="font-size-18 font-weight-500 py-2" width="200">
              Budget
            </td>
            <td class="font-size-18 py-2">
              <span
                class="text--uppercase pr-2"
                v-if="projectArr && projectArr.project_budget"
                >{{ formatMoney(projectArr.project_budget) }}</span
              >
              <em v-else class="text--secondary"> no Project Budget</em>
            </td>
          </tr>
          <tr>
            <td class="font-size-18 font-weight-500 py-2" width="200">
              Customer Purchase Order
            </td>
            <td class="font-size-18 py-2">
              <span
                class="text--uppercase pr-2"
                v-if="projectArr.customer_purchase_order"
                >{{ projectArr.customer_purchase_order }}</span
              >
              <em v-else class="text--secondary">
                no Customer Purchase Order</em
              >
            </td>
          </tr>
        </table>

        <!-- BANKER GUARANTEE CARD -->
        <v-card outlined class="shadow-0 mb-4 overflow-hidden">
          <v-card-title
            class="py-2 px-4 d-flex align-items-center justify-content-between border-bottom gray-background"
          >
            <div class="d-flex align-items-center">
              <v-icon small color="cyan darken-2" class="mr-2">mdi-bank</v-icon>
              <span
                class="font-size-16 text-capitalize color-custom-blue font-weight-700 text-uppercase"
              >
                Banker Guarantee
              </span>
            </div>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon small v-bind="attrs" v-on="on" @click="attchments">
                  <v-icon color="cyan darken-2">mdi-paperclip</v-icon>
                </v-btn>
              </template>
              <span>Attachments</span>
            </v-tooltip>
          </v-card-title>

          <v-card-text class="pa-4">
            <v-simple-table dense class="table-borderless">
              <template v-slot:default>
                <tbody>
                  <tr>
                    <td
                      class="font-size-16 font-weight-500 text-secondary py-2"
                      style="width: 180px"
                    >
                      Bank Name
                    </td>
                    <td class="font-size-16 py-2">
                      <span
                        v-if="projectArr.bank_name"
                        class="text-uppercase font-weight-600 color-custom-blue"
                      >
                        {{ projectArr.bank_name }}
                      </span>
                      <em v-else class="text--secondary">No bank name</em>
                    </td>
                  </tr>

                  <tr>
                    <td
                      class="font-size-16 font-weight-500 text-secondary py-2"
                    >
                      Bank Amount
                    </td>
                    <td class="font-size-16 py-2">
                      <span
                        v-if="projectArr.bank_amount"
                        class="font-weight-bold green--text text--darken-2"
                      >
                        {{ formatMoney(projectArr.bank_amount) }}
                      </span>
                      <em v-else class="text--secondary">No bank amount</em>
                    </td>
                  </tr>

                  <tr>
                    <td
                      class="font-size-16 font-weight-500 text-secondary py-2"
                    >
                      Remark
                    </td>
                    <td class="font-size-16 py-2">
                      <span v-if="projectArr.bank_remark">
                        {{ projectArr.bank_remark }}
                      </span>
                      <em v-else class="text--secondary">No remark</em>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </v-card>

        <!-- INSURANCE PROJECT CARD -->
        <v-card outlined class="shadow-0 mb-4 overflow-hidden">
          <v-card-title
            class="py-2 px-4 d-flex align-items-center justify-content-between border-bottom gray-background"
          >
            <div class="d-flex align-items-center">
              <v-icon small color="cyan darken-2" class="mr-2"
                >mdi-shield-check</v-icon
              >
              <span
                class="font-size-16 text-capitalize color-custom-blue font-weight-700 text-uppercase"
              >
                Insurance Project
              </span>
            </div>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon small v-bind="attrs" v-on="on" @click="attchments">
                  <v-icon color="cyan darken-2">mdi-paperclip</v-icon>
                </v-btn>
              </template>
              <span>Attachments</span>
            </v-tooltip>
          </v-card-title>

          <v-card-text class="pa-4">
            <v-simple-table dense class="table-borderless">
              <template v-slot:default>
                <tbody>
                  <tr>
                    <td
                      class="font-size-16 font-weight-500 text-secondary py-2"
                      style="width: 180px"
                    >
                      Company
                    </td>
                    <td class="font-size-16 py-2">
                      <span
                        v-if="projectArr.insurance_company"
                        class="font-weight-600 color-custom-blue"
                      >
                        {{ projectArr.insurance_company }}
                      </span>
                      <em v-else class="text--secondary"
                        >No insurance company</em
                      >
                    </td>
                  </tr>

                  <tr>
                    <td
                      class="font-size-16 font-weight-500 text-secondary py-2"
                    >
                      Amount
                    </td>
                    <td class="font-size-16 py-2">
                      <span
                        v-if="projectArr.insurance_amount"
                        class="font-weight-bold green--text text--darken-2"
                      >
                        {{ formatMoney(projectArr.insurance_amount) }}
                      </span>
                      <em v-else class="text--secondary"
                        >No insurance amount</em
                      >
                    </td>
                  </tr>

                  <tr>
                    <td
                      class="font-size-16 font-weight-500 text-secondary py-2"
                    >
                      Remark
                    </td>
                    <td class="font-size-16 py-2">
                      <span v-if="projectArr.insurance_remark">
                        {{ projectArr.insurance_remark }}
                      </span>
                      <em v-else class="text--secondary">No remark</em>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- DIALOGS -->
    <template v-if="getPermission('project:update')">
      <Dialog :commonDialog="memberDialog">
        <template v-slot:title>Members</template>
        <template v-slot:body>
          <v-container class="py-0">
            <v-row>
              <v-col md="12" class="py-0">
                <v-autocomplete
                  dense
                  color="cyan"
                  filled
                  :items="memberList"
                  :disabled="pageLoading"
                  :loading="pageLoading"
                  v-model.trim="members"
                  placeholder="Members"
                  solo
                  flat
                  item-color="cyan"
                  item-text="full_name"
                  item-value="id"
                  hide-details
                  multiple
                >
                  <template v-slot:selection="{ item, index }">
                    <v-chip v-if="index < 3">
                      <span>{{ item.full_name }}</span>
                    </v-chip>
                    <span v-if="index === 3" class="grey--text font-size-12">
                      <template v-if="members && members.length"
                        >(+{{ members.length - 3 }} others)</template
                      >
                    </span>
                  </template>
                  <template v-slot:no-data>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title
                          v-html="'No Member Found.'"
                        ></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
          </v-container>
        </template>
        <template v-slot:action>
          <v-container class="py-0">
            <v-row>
              <v-col md="12" class="text-right">
                <v-btn
                  depressed
                  v-on:click="memberDialog = false"
                  :disabled="pageLoading"
                  class="mx-2 custom-grey-border custom-bold-button"
                >
                  Cancel
                </v-btn>
                <v-btn
                  depressed
                  :disabled="pageLoading"
                  :loading="pageLoading"
                  class="mx-2 custom-bold-button white--text"
                  v-on:click="updateMembers"
                  color="cyan"
                >
                  Save
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </template>
      </Dialog>
    </template>

    <template v-if="getPermission('project:update')">
      <Dialog :commonDialog="managerDialog">
        <template v-slot:title>Managers</template>
        <template v-slot:body>
          <v-container class="py-0">
            <v-row>
              <v-col md="12" class="py-0">
                <v-autocomplete
                  dense
                  color="cyan"
                  filled
                  :items="managerList"
                  :disabled="pageLoading"
                  :loading="pageLoading"
                  v-model.trim="managers"
                  placeholder="Managers"
                  solo
                  flat
                  item-color="cyan"
                  item-text="full_name"
                  item-value="id"
                  hide-details
                  multiple
                >
                  <template v-slot:selection="{ item, index }">
                    <v-chip v-if="index < 3">
                      <span>{{ item.full_name }}</span>
                    </v-chip>
                    <span v-if="index === 3" class="grey--text font-size-12">
                      <template v-if="managers && managers.length"
                        >(+{{ managers.length - 3 }} others)</template
                      >
                    </span>
                  </template>
                  <template v-slot:no-data>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title
                          v-html="'No Member Found.'"
                        ></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
          </v-container>
        </template>
        <template v-slot:action>
          <v-container class="py-0">
            <v-row>
              <v-col md="12" class="text-right">
                <v-btn
                  depressed
                  v-on:click="managerDialog = false"
                  :disabled="pageLoading"
                  class="mx-2 custom-grey-border custom-bold-button"
                >
                  Cancel
                </v-btn>
                <v-btn
                  depressed
                  :disabled="pageLoading"
                  :loading="pageLoading"
                  class="mx-2 custom-bold-button white--text"
                  v-on:click="updateManagers"
                  color="cyan"
                >
                  Save
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </template>
      </Dialog>
    </template>

    <template v-if="getPermission('project:delete')">
      <MemberDelete :deleteDialog="deleteManagerDialog">
        <template v-slot:title>Delete Confirmation</template>
        <template v-slot:text>
          <h3 class="font-size-16 font-weight-500 delete-text">
            Once you delete
            <span class="">{{ deleteDetail.full_name }}</span
            >, you won't be able to retrieve this later. Are you sure you want
            to delete
            <span class="">{{ deleteDetail.full_name }}</span>
            ?
          </h3>
        </template>
        <template v-slot:action>
          <v-btn
            depressed
            :disabled="deleteLoading"
            :loading="deleteLoading"
            class="mx-2 custom-bold-button white--text"
            color="red lighten-1"
            v-on:click="deleteMangerConfirm"
          >
            Yes, Delete it
          </v-btn>

          <v-btn
            depressed
            :disabled="deleteLoading"
            class="mx-2 custom-grey-border custom-bold-button"
            v-on:click="deleteManagerDialog = false"
          >
            No, Keep it
          </v-btn>
        </template>
      </MemberDelete>
    </template>

    <template v-if="getPermission('project:delete')">
      <MemberDelete :deleteDialog="deleteMemberDialog">
        <template v-slot:title>Delete Confirmation</template>
        <template v-slot:text>
          <h3 class="font-size-16 font-weight-500 delete-text">
            Once you delete
            <span class="">{{ deleteDetail.full_name }}</span
            >, you won't be able to retrieve this later. Are you sure you want
            to delete
            <span class="">{{ deleteDetail.full_name }}</span>
            ?
          </h3>
        </template>
        <template v-slot:action>
          <v-btn
            depressed
            :disabled="deleteLoading"
            :loading="deleteLoading"
            class="mx-2 custom-bold-button white--text"
            color="red lighten-1"
            v-on:click="deleteMemberConfirm"
          >
            Yes, Delete it
          </v-btn>

          <v-btn
            depressed
            :disabled="deleteLoading"
            class="mx-2 custom-grey-border custom-bold-button"
            v-on:click="deleteMemberDialog = false"
          >
            No, Keep it
          </v-btn>
        </template>
      </MemberDelete>
    </template>
  </v-container>
</template>

<script>
import { GET, DELETE, PATCH } from "@/core/services/store/request.module";
import CommonMixin from "@/core/plugins/common-mixin";
import ValidationMixin from "@/core/plugins/validation-mixin";
import MemberDelete from "@/view/pages/partials/Delete.vue";
import Dialog from "@/view/pages/partials/Dialog.vue";

export default {
  name: "project-detail",
  title: "Project",
  mixins: [CommonMixin, ValidationMixin],
  props: {
    projectArr: {
      type: [Object],
      required: true,
      default: () => {
        return new Object();
      },
    },
    project: {
      type: Number,
      required: true,
      default: 0,
    },
  },
  watch: {
    "projectArr.members"(members) {
      if (members && members.length > 0) {
        this.members = members.map((row) => {
          return row.user.id;
        });
      }
    },
    "projectArr.managers"(managers) {
      if (managers && managers.length > 0) {
        this.managers = managers.map((row) => {
          return row.user.id;
        });
      }
    },
  },
  data() {
    return {
      memberDialog: false,
      pageLoading: false,
      deleteDetail: new Object(),
      deleteMemberDialog: false,
      deleteManagerDialog: false,
      members: [],
      memberList: [],
      managers: [],
      managerList: [],
      managerDialog: false,
      loggedHours: "this_week",
      loggedHourLoading: false,
      loggedHourSeries: [{ data: [] }],
      loggedHourChartoptions: {
        chart: {
          type: "bar",
          height: 350,
        },
        plotOptions: {
          bar: {
            borderRadius: 2,
          },
        },
        dataLabels: {
          enabled: false,
        },
        xaxis: {
          categories: [],
        },
      },
      durationList: [
        { text: "This Week", value: "this_week" },
        { text: "Last Week", value: "last_week" },
        { text: "This Month", value: "this_month" },
        { text: "Last Month", value: "last_month" },
        { text: "This Year", value: "this_year" },
        { text: "Last Year", value: "last_year" },
      ],
    };
  },
  components: {
    Dialog,
    MemberDelete,
  },
  methods: {
    attchments() {
      let query = { ...this.$route.query };
      query.tab = "attachment";
      this.$router.push({ query });
    },
    deleteMember(member) {
      this.deleteDetail = member;
      this.deleteMemberDialog = true;
    },
    deleteMemberConfirm() {
      const _this = this;
      _this.deleteLoading = true;
      _this.$store
        .dispatch(DELETE, {
          url: "project/" + _this.project + "/members/" + _this.deleteDetail.id,
        })
        .then(() => {
          _this.$emit("reload:project", true);
          _this.deleteDetail = new Object();
          _this.deleteMemberDialog = false;
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.deleteLoading = false;
        });
    },
    deleteManager(member) {
      this.deleteDetail = member;
      this.deleteManagerDialog = true;
    },
    deleteMangerConfirm() {
      const _this = this;
      _this.deleteLoading = true;
      _this.$store
        .dispatch(DELETE, {
          url:
            "project/" + _this.project + "/managers/" + _this.deleteDetail.id,
        })
        .then(() => {
          _this.$emit("reload:project", true);
          _this.deleteDetail = new Object();
          _this.deleteManagerDialog = false;
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.deleteLoading = false;
        });
    },
    updateMembers() {
      const _this = this;
      _this.pageLoading = true;
      _this.$store
        .dispatch(PATCH, {
          url: "project/" + _this.project + "/members",
          data: { members: _this.members },
        })
        .then(() => {
          _this.$emit("reload:project", true);
          _this.memberDialog = false;
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.pageLoading = false;
        });
    },
    updateManagers() {
      const _this = this;
      _this.pageLoading = true;
      _this.$store
        .dispatch(PATCH, {
          url: "project/" + _this.project + "/managers",
          data: { managers: _this.managers },
        })
        .then(() => {
          _this.$emit("reload:project", true);
          _this.managerDialog = false;
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.pageLoading = false;
        });
    },
    getMembers() {
      const _this = this;
      _this.$store
        .dispatch(GET, {
          url: "project/members",
        })
        .then(({ data }) => {
          _this.memberList = data;
          _this.managerList = data;
        })
        .catch((error) => {
          _this.logError(error);
        });
    },
    getLoggedHours() {
      const _this = this;
      _this.$store
        .dispatch(GET, {
          url: "project/" + _this.project + "/graph/" + _this.loggedHours,
        })
        .then(({ data }) => {
          _this.loggedHourChartoptions = {
            ..._this.loggedHourChartoptions,
            ...{
              xaxis: {
                categories: data.categories,
              },
            },
          };
          _this.loggedHourSeries = [
            { name: "Logged Hours", data: data.values },
          ];
        })
        .catch((error) => {
          _this.logError(error);
        });
    },
  },
  mounted() {
    this.getMembers();
    this.getLoggedHours();
  },
};
</script>
